import api from '../utils/api';

// Subscription service for API calls
export const subscriptionService = {
  // Get available pricing plans with query parameters
  getAvailablePricingPlans: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const response = await api.get(`/available-pricing-plans?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Subscribe to a pricing plan
  subscribeToPlan: async (pricingPlanId) => {
    try {
      const response = await api.post('/subscriptions/subscribe', {
        pricing_plan_id: pricingPlanId
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all active subscriptions with query parameters
  getActiveSubscriptions: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const response = await api.get(`/subscriptions/active?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all subscriptions with query parameters
  getAllSubscriptions: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const response = await api.get(`/subscriptions/all?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get single subscription details
  getSubscriptionDetails: async (subscriptionId) => {
    try {
      const response = await api.get(`/subscriptions/${subscriptionId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get subscription periods list
  getSubscriptionPeriods: async (subscriptionId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const response = await api.get(`/subscriptions/${subscriptionId}/periods?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get single subscription period details
  getSubscriptionPeriodDetails: async (periodId) => {
    try {
      const response = await api.get(`/subscriptions/periods/${periodId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Toggle auto-renew for a specific subscription
  toggleAutoRenew: async (subscriptionId, autoRenew) => {
    try {
      const response = await api.patch(`/subscriptions/${subscriptionId}/auto-renew`, {
        auto_renew: autoRenew
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Cancel subscription
  cancelSubscription: async (subscriptionId, reason) => {
    try {
      const response = await api.post(`/subscriptions/${subscriptionId}/cancel`, {
        reason: reason
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add-on storage management (Super Admin only)
  addOnStorage: async (userId, storage, notes) => {
    try {
      const response = await api.post(`/admin/add-on-storage/${userId}/add`, {
        add_on_storage: storage,
        notes: notes
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default subscriptionService;